export default "__VITE_ASSET__CcEFm9Kq__"